import React from "react";
import useApplicantProfile from "./useApplicantProfile";
import { dateFormatter } from "../../../../_helpers/dateFormatter";

export default (props) => {
  const { userProfileInfo } = useApplicantProfile(props);
  return (
    <>
      <div className="applicant-profile row no-gutters bg-white border border-radius-10">
        <div className="col-12 mb-4">
          <div className="text-capitalize mb-4 p-3">
            <h3 className="mb-2 font-weight-medium">Top 5 skills</h3>
            {/* candidate skills to be shown here */}
            <div>
              <ul className="d-flex align-items-center flex-wrap">
                {userProfileInfo?.skills?.length ? (
                  Array.isArray(userProfileInfo?.skills) &&
                  userProfileInfo?.skills?.map((item) => (
                    <li className="bg-grey-3 rounded h4 font-weight-normal px-2 py-1 mr-2">
                      {item.skill_name}
                    </li>
                  ))
                ) : (
                  <p className="font-weight-medium">Not Available</p>
                )}
              </ul>
            </div>
          </div>

          <div className="col-12">
            <div className="custom-card bg-white rounded-lg">
              <h3 className="mb-3 font-weight-medium">General Information</h3>
              <div className="row">
                <div className="col-lg-4">
                  <p className="mb-0 text-grey-4 font-weight-medium mb-1">
                    Name
                  </p>
                  <p className="font-weight-medium text-capitalize">
                    {userProfileInfo?.user_details?.full_name}
                  </p>
                </div>
                {userProfileInfo?.dob &&
                  <div className="col-lg-6 col-xl-4">
                    <p className="mb-0 font-weight-medium text-grey-4 mb-1">
                      Date of Birth
                    </p>
                    <p className="font-weight-medium">
                      {userProfileInfo?.dob}
                    </p>
                  </div>
                }
                {userProfileInfo?.gender &&
                  <div className="col-lg-6 col-xl-4">
                    <p className="mb-0 font-weight-medium text-grey-4 mb-1">
                      Gender
                    </p>
                    <p className="font-weight-medium text-capitalize">
                      {userProfileInfo?.gender}
                    </p>
                  </div>
                }
                <div
                  className={`col-lg-4 ${userProfileInfo.candidate_profile_details?.city_name
                    ? "d-block"
                    : "d-none"
                    }`}
                >
                  <div className="mb-0 font-weight-medium text-grey-4 mb-1">
                    <p>Location</p>
                    <p className="font-weight-medium text-capitalize">
                      {userProfileInfo?.candidate_profile_details &&
                        userProfileInfo.candidate_profile_details?.city_name}
                      ,
                      {userProfileInfo?.candidate_profile_details &&
                        userProfileInfo.candidate_profile_details
                          ?.country_name &&
                        userProfileInfo.candidate_profile_details.country_name}
                    </p>
                  </div>
                </div>
                {userProfileInfo?.candidate_website && (
                  <div className="col-lg-4">
                    <p className="mb-0 font-weight-medium  text-grey-4 mb-1">
                      Website
                    </p>
                    <p className="font-weight-medium">
                      <a
                        href={userProfileInfo?.candidate_website}
                        target="_blank"
                      >
                        {userProfileInfo?.candidate_website && userProfileInfo.candidate_website.substring(
                          0,
                          30
                        ) + "..."}
                      </a>
                    </p>
                  </div>
                )}
                {userProfileInfo?.linkedin_url && (
                  <div className="col-lg-4">
                    <p className="mb-0 font-weight-medium  text-grey-4 mb-1">
                      LinkedIn
                    </p>
                    <p className="font-weight-medium">
                      <a href={userProfileInfo?.linkedin_url} target="_blank">
                        {userProfileInfo?.linkedin_url && userProfileInfo.linkedin_url.substring(
                          0,
                          30
                        ) + "..."}
                      </a>
                    </p>
                  </div>
                )}
                {userProfileInfo?.github_url && (
                  <div className="col-lg-4">
                    <p className="mb-0 font-weight-medium text-grey-4 mb-1">
                      Github
                    </p>
                    <p className="font-weight-medium">
                      <a href={userProfileInfo?.github_url} target="_blank">
                        {userProfileInfo?.github_url && userProfileInfo.github_url.substring(
                          0,
                          30
                        ) + "..."}
                      </a>
                    </p>
                  </div>
                )}

                {userProfileInfo?.portfolio &&
                  Array.isArray(userProfileInfo?.portfolio) &&
                  userProfileInfo.portfolio.length
                  ?
                  <div className="col-lg-4">
                    <p className="mb-0 font-weight-medium text-grey-4 mb-1">
                      Portfolio
                    </p>
                    <p className="font-weight-medium">
                      {Array.isArray(userProfileInfo?.portfolio) &&
                        userProfileInfo.portfolio.map((item) => (
                          <p className="mb-0">
                            <a target="_blank" href={item.portfolio_url}>
                              {item?.portfolio_url && item.portfolio_url.substring(
                                0,
                                30
                              ) + "..."}
                            </a>
                          </p>
                        ))}
                    </p>
                  </div>
                  : null}
              </div>
            </div>
          </div>

          <div className="profession col-12 my-5">
            <div className="custom-card rounded-lg">
              <h3 className="mb-2 font-weight-medium">
                Professional Information
              </h3>
              <div className="bg-white">
                <ul className="info-list text-capitalize">
                  {Array.isArray(userProfileInfo?.work_experience) &&
                    userProfileInfo.work_experience?.length ? (
                    Array.isArray(userProfileInfo?.work_experience) &&
                    userProfileInfo.work_experience?.map((data) => (
                      <li className="mt-3 p-4 rounded-lg border">
                        <div className="d-flex align-items-center justify-content-between">
                          <div>
                            <h3 className="font-weight-medium mb-1 text-uppercase">
                              {data?.job_title}
                            </h3>
                            <p className=" mb-1 d-inline-block mr-3">
                              {data?.company_name}
                            </p>
                            <span className="study mb-1">
                              {data?.employment_type.replace(/_/g, "-")}
                            </span>
                          </div>
                          <div>
                            <p className="text-grey-4 mb-1">
                              {dateFormatter(data?.start_date)} -{" "}
                              {data?.currently_working_here === true
                                ? "currently working here"
                                : dateFormatter(data?.end_date)}
                            </p>
                            <p className="text-grey-4 mb-1 d-inline-block mr-1">
                              {data?.city_name ? (
                                <>{data?.city_name}, </>
                              ) : null}
                            </p>
                            <p className="text-grey-4 mb-1 d-inline-block mr-1">
                              {data?.state_name ? (
                                <>{data?.state_name}, </>
                              ) : null}
                            </p>
                            <p className="text-grey-4 text-Uppercase mb-0 d-inline-block">
                              {data?.country_name}
                            </p>
                          </div>
                        </div>
                        <p className="text-grey-4 my-3 d-inline-block">
                          {data?.description}
                        </p>
                        <ul className="d-flex align-items-center flex-wrap">
                          {Array.isArray(data?.skill_names) &&
                            data?.skill_names.map((item) => (
                              <li className="bg-grey-3 rounded h4 font-weight-normal px-2 py-1 mr-2">
                                {item}
                              </li>
                            ))}
                        </ul>
                      </li>
                    ))
                  ) : (
                    <p className="font-weight-medium  p-4 rounded-lg border">
                      Not Available
                    </p>
                  )}
                </ul>
              </div>
            </div>
          </div>
          <div className="education col-12 mb-4 ">
            <div className="custom-card">
              <h3 className="mb-2 font-weight-medium">
                Educational Information
              </h3>
              <div className="bg-white">
                <ul className="info-list">
                  {userProfileInfo.education &&
                    Array.isArray(userProfileInfo?.education) &&
                    userProfileInfo.education?.length ? (
                    Array.isArray(userProfileInfo?.education) &&
                    userProfileInfo.education?.map((data) => (
                      <li className="mt-3  p-4 rounded-lg border">
                        <h3 className="mb-1 font-weight-medium">
                          {data?.school_name && data.school_name.toUpperCase()}
                        </h3>

                        <div className="d-flex">
                          <p className="mb-1 mr-3 text-uppercase">
                            {data?.college_degree_name}
                          </p>
                          {data?.field_of_study_name ? (
                            <p className="study mb-1 text-capitalize">
                              {data?.field_of_study_name}
                            </p>
                          ) : null}
                        </div>
                        <p className="text-grey-4">
                          {dateFormatter(data?.start_date)} -{" "}
                          {dateFormatter(data?.end_date)}
                        </p>
                      </li>
                    ))
                  ) : (
                    <p className="font-weight-medium  p-4 rounded-lg border">
                      Not Available
                    </p>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
